<template>
    <div class="home-pin-wrapper">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="home1 hero-main-section">
                    <div class="columns is-vcentered">
                        <div class="column is-6">
                            <div class="carousel-container">
                                <b-carousel :repeat="true" :autoplay="true" indicator-custom :indicator-inside="false"
                                    @click="switchGallery(true)">
                                    <b-carousel-item v-for="(item, i) in 5" :key="i">
                                        <b-image class="image carousel-image" :src="getImgUrl(i)" 
                                            @click.stop="openImageModal(getImgUrl(i), getImageAlt(i))"></b-image>
                                    </b-carousel-item>
                                    <template #indicators="props">
                                        <b-image class="al image carousel-indicator" :src="getImgUrl(props.i)" :title="props.i"
                                            @click="openImageModal(getImgUrl(props.i), getImageAlt(props.i))"></b-image>
                                    </template>
                                </b-carousel>
                            </div>
                        </div>
                        <div class="column is-6 hero-content-column">
                            <div class="hero-content">
                                <div class="brand-section">
                                    <h1 class="title is-1 brand-title">
                                        <span class="icon is-large brand-icon">
                                            <i class="fas fa-gas-pump"></i>
                                        </span>
                                        <span class="brand-text"><span class="brand-combu">C O M B U</span> <span class="highlight">s t i b i l</span></span>
                                    </h1>
                                    <h2 class="subtitle is-4 brand-subtitle" v-show="!emailSent">
                                        Platforma completă pentru gestionarea vehiculelor tale
                                    </h2>
                                </div>

                                <div class="auth-section" v-show="!loggedIn">
                                    <form v-show="!emailSent" @submit.prevent="sendEmail" class="login-form">
                                        <div class="field">
                                            <div class="control has-icons-left">
                                                <input v-model="email" class="input is-large email-input" type="email"
                                                    required placeholder="Adresa ta de email" />
                                                <span class="icon is-large is-left">
                                                    <i class="fas fa-envelope"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="field">
                                            <div class="control">
                                                <b-button class="button is-primary is-large is-fullwidth login-button" 
                                                    :loading="isLoading" native-type="submit">
                                                    <span class="icon">
                                                        <i class="fas fa-rocket"></i>
                                                    </span>
                                                    <span>Începe gratuit</span>
                                                </b-button>
                                            </div>
                                        </div>
                                        <p class="help auth-help">
                                            <i class="fas fa-info-circle"></i>
                                            Vei primi un cod de autentificare pe email - nu este nevoie de parolă
                                        </p>
                                    </form>

                                    <div v-show="emailSent" class="verification-section">
                                        <h3 class="title is-5 verification-title">
                                            <i class="fas fa-shield-check"></i>
                                            Verifică-ți emailul
                                        </h3>
                                        <p class="verification-text">
                                            Introdu codul de 4 cifre primit pe <strong>{{ email }}</strong>
                                        </p>
                                        <div class="field is-grouped is-justify-content-center code-inputs" @paste="handlePaste">
                                            <b-field v-for="n in 4" :key="n">
                                                <b-input type="text" inputmode="numeric" v-model="digits[n - 1]" 
                                                    style="width: 3.5rem; text-align: center;"
                                                    class="code-input is-large" size="is-large" maxlength="1"
                                                    :has-counter="false" @input="moveToNext(n - 1)" ref="codeInput"
                                                    @focus="(ev) => ev.target.select()"></b-input>
                                            </b-field>
                                        </div>
                                        <div class="verification-actions">
                                            <b-button :disabled="digits.join('').length < 4" @click="doLogin" ref="verifyButton"
                                                class="button is-primary is-large is-fullwidth" :loading="isLoadingPin">
                                                <span class="icon">
                                                    <i class="fas fa-check"></i>
                                                </span>
                                                <span>Verifică codul</span>
                                            </b-button>
                                        </div>
                                        <div v-show="isInvalidCode" class="invalid-code-message"> 
                                            <b-message type="is-warning" has-icon>
                                                Codul este invalid! 
                                                <a @click="sendEmail" class="resend-link">Trimite cod nou</a> 
                                            </b-message>
                                        </div>
                                    </div>
                                </div>

                                <div class="dashboard-link" v-show="loggedIn">
                                    <router-link class="button is-primary is-large dashboard-button" to="/dashboard">
                                        <span class="icon">
                                            <i class="fas fa-tachometer-alt"></i>
                                        </span>
                                        <span>Accesează Dashboard</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Feature sections for each image -->
                <div class="container">
                    <div class="section">
                        <h2 class="title has-text-centered is-3">Funcționalități</h2>
                        
                        <!-- Dashboard Feature -->
                        <div class="columns is-vcentered feature-section">
                            <div class="column is-half">
                                <figure class="image clickable-image" @click="openImageModal('/img/dashboard.png', 'Dashboard')">
                                    <img src="/img/dashboard.png" alt="Dashboard" class="feature-image">
                                </figure>
                            </div>
                            <div class="column is-half feature-text">
                                <h3 class="title is-4">Dashboard Intuitiv</h3>
                                <p class="subtitle is-6">
                                    Vizualizează toate informațiile importante despre vehiculele tale într-un dashboard modern și ușor de folosit. 
                                    Monitorizează consumul de carburant, asigurările și cheltuielile într-o singură privire.
                                </p>
                            </div>
                        </div>

                        <!-- Insurances Feature -->
                        <div class="columns is-vcentered feature-section">
                            <div class="column is-half is-hidden-mobile">
                                <div class="feature-text has-text-right">
                                    <h3 class="title is-4">Gestionare Asigurări</h3>
                                    <p class="subtitle is-6">
                                        Ține evidența tuturor asigurărilor auto și primește notificări înainte de expirare. 
                                        Nu vei mai uita să îți reînnoiești asigurările cu sistemul nostru de alerte.
                                    </p>
                                </div>
                            </div>
                            <div class="column is-half">
                                <figure class="image clickable-image" @click="openImageModal('/img/insurances.png', 'Asigurări')">
                                    <img src="/img/insurances.png" alt="Asigurări" class="feature-image">
                                </figure>
                            </div>
                            <div class="column is-half is-hidden-tablet feature-text">
                                <h3 class="title is-4">Gestionare Asigurări</h3>
                                <p class="subtitle is-6">
                                    Ține evidența tuturor asigurărilor auto și primește notificări înainte de expirare. 
                                    Nu mai uita să îți reînnoiești asigurarea cu sistemul nostru de alerte.
                                </p>
                            </div>
                        </div>

                        <!-- Expenses Feature -->
                        <div class="columns is-vcentered feature-section">
                            <div class="column is-half">
                                <figure class="image clickable-image" @click="openImageModal('/img/expenses.png', 'Cheltuieli')">
                                    <img src="/img/expenses.png" alt="Cheltuieli" class="feature-image">
                                </figure>
                            </div>
                            <div class="column is-half feature-text">
                                <h3 class="title is-4">Urmărire Cheltuieli</h3>
                                <p class="subtitle is-6">
                                    Înregistrează și categorisează toate cheltuielile legate de vehiculele tale. 
                                    De la combustibil la reparații, păstrează evidența completă a costurilor.
                                </p>
                            </div>
                        </div>

                        <!-- Calendar Feature -->
                        <div class="columns is-vcentered feature-section">
                            <div class="column is-half is-hidden-mobile">
                                <div class="feature-text has-text-right">
                                    <h3 class="title is-4">Calendar</h3>
                                    <p class="subtitle is-6">
                                        Urmărește toate evenimentele importante: ITP, revizie tehnică, 
                                        schimbare ulei și multe altele. Nu rata niciodată o întreținere importantă.
                                    </p>
                                </div>
                            </div>
                            <div class="column is-half">
                                <figure class="image clickable-image" @click="openImageModal('/img/calendar.png', 'Calendar')">
                                    <img src="/img/calendar.png" alt="Calendar" class="feature-image">
                                </figure>
                            </div>
                            <div class="column is-half is-hidden-tablet feature-text">
                                <h3 class="title is-4">Calendar Integrat</h3>
                                <p class="subtitle is-6">
                                    Programează și urmărește toate evenimentele importante: ITP, revizie tehnică, 
                                    schimbare ulei și multe altele. Nu rata niciodată o întreținere importantă.
                                </p>
                            </div>
                        </div>

                        <!-- Email Notifications Feature -->
                        <div class="columns is-vcentered feature-section">
                            <div class="column is-half">
                                <figure class="image clickable-image" @click="openImageModal('/img/email.png', 'Notificări Email')">
                                    <img src="/img/email.png" alt="Notificări Email" class="feature-image">
                                </figure>
                            </div>
                            <div class="column is-half feature-text">
                                <h3 class="title is-4">Notificări Email</h3>
                                <p class="subtitle is-6">
                                    Primește alerte personalizate pe email pentru toate evenimentele importante. 
                                    Rămâi informat despre expirări, programări și alte date critice.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Call to Action Section -->
                <div class="container">
                    <div class="section cta-section">
                        <div class="columns is-centered">
                            <div class="column is-8 has-text-centered">
                                <h2 class="title is-3 cta-title">Gata să îți simplifici gestionarea vehiculelor?</h2>
                                <p class="subtitle is-5 cta-subtitle">
                                   Optimizează gestionarea vehiculelor cu COMBU.ro. <br>
                                   Monitorizează ușor consumul de combustibil, asigurările și toate cheltuielile auto – simplu, eficient și într-un singur loc.
                                </p>
                                <div class="cta-benefits">
                                    <div class="columns is-multiline">
                                        <div class="column is-4">
                                            <div class="benefit-item">
                                                <span class="icon is-large has-text-primary">
                                                    <i class="fas fa-check-circle fa-2x"></i>
                                                </span>
                                                <p class="benefit-text">Primul vehicul gratuit</p>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="benefit-item">
                                                <span class="icon is-large has-text-primary">
                                                    <i class="fas fa-mobile-alt fa-2x"></i>
                                                </span>
                                                <p class="benefit-text">Acces de pe orice dispozitiv</p>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="benefit-item">
                                                <span class="icon is-large has-text-primary">
                                                    <i class="fas fa-shield-alt fa-2x"></i>
                                                </span>
                                                <p class="benefit-text">Datele tale sunt sigure</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cta-buttons">
                                    <button class="button is-primary is-large cta-button" @click="scrollToLogin">
                                        <span class="icon">
                                            <i class="fas fa-rocket"></i>
                                        </span>
                                        <span>Începe acum - este gratuit!</span>
                                    </button>
                                    <p class="cta-note">Nu este nevoie de card de credit</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Image Modal -->
        <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
            <div class="modal-background" @click="closeImageModal"></div>
            <div class="modal-content">
                <div class="modal-image-container">
                    <img :src="modalImageSrc" :alt="modalImageAlt" class="modal-image" @click.stop>
                    <button class="modal-close" @click="closeImageModal" aria-label="close">
                        <span>&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//import Welcome from "@/components/Welcome.vue";
import Vue from "vue";

import { mapGetters, mapActions } from "vuex";
import { isLoggedIn, login, logout, isAuthenticated } from "../utils/auth";

export default {
    name: "home",
    data() {
        return {
            url: process.env.VUE_APP_REDIRECT,
            landingUrl: "/img/combu_landing.jpeg",
            loggedIn: false,
            emailSent: false,
            email: "",
            isLoading: false,
            isLoadingPin: false,
            isInvalidCode : false,
            gallery: false,
            images: [
                // "/img/combu_landing.jpeg",
                "/img/dashboard.png",
                "/img/insurances.png",
                "/img/expenses.png",
                "/img/calendar.png",
                "/img/email.png",
            ],
            digits: ['', '', '', ''],
            showImageModal: false,
            modalImageSrc: '',
            modalImageAlt: ''

        };
    },
    computed: {
        emailUrl: function () {
            return this.email ? `https://${this.email.split("@").pop()}` : "";
        },
    },
    methods: {
        ...mapActions(["loadInitial", "loginByEmailPin", "authenticateByEmailAndToken"]),
        getImgUrl(value) {
            return this.images[value];
            // value += 50
            // return `https://picsum.photos/id/10${value}/1230/500`
        },
        getImageAlt(index) {
            const altTexts = [
                'Dashboard',
                'Asigurări',
                'Cheltuieli',
                'Calendar',
                'Notificări Email'
            ];
            return altTexts[index] || 'Feature Image';
        },
        switchGallery(value) {
            this.gallery = value
            if (value) {
                // return document.documentElement.classList.add('is-clipped')
            } else {
                // return document.documentElement.classList.remove('is-clipped')
            }
        },
        async sendEmail() {
            this.isInvalidCode = false;
            this.digits = ['', '', '', ''];    
            if (!this.email) return;
            this.isLoading = true;
            await this.loginByEmailPin(this.email);
            this.emailSent = true;
            this.$refs.codeInput[0].focus();
        },
        handleLogin() {
            window.location = `${window.location.href}.auth/login/google?post_login_redirect_uri=${window.location.href}callback`;
            //login();
        },
        async moveToNext(index) {
            if (index < 3) {
                this.$nextTick(() => {
                    if (this.digits[index].length === 1) {
                        this.$refs.codeInput[index + 1].focus();
                        if(this.$refs.codeInput[index + 1].select) 
                            this.$refs.codeInput[index + 1].select();
                    }
                });
            } else if (this.digits.join('').length === 4){
                this.$refs.verifyButton.$el.focus();    
                await this.doLogin();
            }
        },

        handlePaste(event, currentIndex) {
            // Prevent the default paste behavior
            event.preventDefault();
            
            // Get the pasted text from clipboard
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            
            // Remove all spaces and non-alphanumeric characters, keep only digits and letters
            const cleanText = pastedText.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
            
            // Only process if we have content
            if (cleanText) {
                // Split the clean text into individual characters, taking only the first 4
                const characters = cleanText.slice(0, 4).split('');
                
                // Clear all digits first
                this.digits = ['', '', '', ''];
                
                // Populate the digits array with the pasted characters
                characters.forEach((char, index) => {
                    if (index < 4) {
                        this.$set(this.digits, index, char.toUpperCase());
                    }
                });
                
                if (this.digits.length === 4) {
                    // If all digits are filled, focus on the verify button
                    this.$refs.verifyButton.$el.focus();
                    this.doLogin();
                }
        
            }
        },

        async doLogin() {
            if (this.digits.join('').length === 4) {
                this.isInvalidCode = false;
                this.isLoadingPin = true;
                var tkn = await this.authenticateByEmailAndToken({
                    email: this.email,
                    token: this.digits.join('')
                });
                
                if (!!tkn) this.$router.push({ name: "dashboard" });
                else{ this.isLoadingPin = false; this.isInvalidCode = true;}                
            }
        },
        getPic() {
            const image = new Image();
            image.src = "https://source.unsplash.com/collection/430968/800x600";

            image.onload = () => {
                this.landingUrl = image.src;
            };
        },
        async showAuthButton() {
            return (await this.isLoggedIn()) == true;
        },
        openImageModal(imageSrc, imageAlt) {
            this.modalImageSrc = imageSrc;
            this.modalImageAlt = imageAlt;
            this.showImageModal = true;
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
            document.addEventListener('keyup', this.handleEscKey);
        },
        closeImageModal() {
            this.showImageModal = false;
            this.modalImageSrc = '';
            this.modalImageAlt = '';
            document.body.style.overflow = 'auto'; // Restore scrolling
            document.removeEventListener('keyup', this.handleEscKey);
        },
        handleEscKey(event) {
            if (event.key === 'Escape') {
                this.closeImageModal();
            }
        },
        scrollToLogin() {
            // Scroll to the top of the page where the login form is
            const loginSection = document.querySelector('.home1');
            if (loginSection) {
                loginSection.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                });
                
                // Focus on the email input after scrolling
                setTimeout(() => {
                    const emailInput = document.querySelector('input[type="email"]');
                    if (emailInput && !this.loggedIn) {
                        emailInput.focus();
                    }
                }, 500);
            }
        },
    },
    async created() {
        this.getPic();
        this.loggedIn = await isLoggedIn();
    },
    beforeDestroy() {
        // Clean up event listeners to prevent memory leaks
        document.removeEventListener('keyup', this.handleEscKey);
        document.body.style.overflow = 'auto';
    },
};
</script>

<style scoped>
h1.title {
    margin-bottom: 50px;
}

.centered-input {
    text-align: center;
}

/* carusel */
.is-active .al img {
    border: 1px solid #fff;
    filter: grayscale(0%);
}

.al img {
    border: 1px solid transparent;
    filter: grayscale(100%);
}

.carousel-image {
    cursor: pointer;
    transition: all 0.3s ease;
}

.carousel-image:hover {
    transform: scale(1.02);
    filter: brightness(1.1);
}

.al img {
    cursor: pointer;
    transition: all 0.3s ease;
}

.al img:hover {
    transform: scale(1.05);
    border-color: #fff !important;
}


.field.is-grouped .b-field {
    margin-right: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

/* Hero Section Styling */
.hero-main-section {
    min-height: 80vh;
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #f8f9ff 0%, #f1f4ff 100%);
    border-radius: 20px;
    margin-bottom: 3rem;
    padding: 3rem 0;
    position: relative;
    overflow: hidden;
}

.hero-main-section::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, transparent 70%);
    animation: heroFloat 8s ease-in-out infinite;
}

@keyframes heroFloat {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-30px) rotate(180deg); }
}

.hero-content {
    position: relative;
    z-index: 2;
}

.hero-content-column {
    overflow: visible;
    min-width: 0;
    flex: 0 0 auto;
}

/* Brand Section */
.brand-section {
    margin-bottom: 2rem;
    text-align: center;
    padding: 0 2rem;
    overflow: visible;
}

.brand-title {
    color: #2c3e50;
    font-weight: 900;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    gap: 0;
    overflow: visible;
    width: 100%;
    padding: 0 1rem;
}

.brand-icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.brand-text {
    letter-spacing: 0.05em;
    position: relative;
    margin: 0 1rem;
    padding: 0 2rem;
    white-space: nowrap;
    display: inline-block;
    min-width: fit-content;
    flex-shrink: 0;
}

.brand-text .brand-combu {
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 900;
    text-shadow: 0 2px 4px rgba(44, 62, 80, 0.3);
}

.brand-text .highlight {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 900;
    font-size: 1em;
    text-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
}

.brand-subtitle {
    color: #5a6c7d;
    font-weight: 500;
    line-height: 1.6;
    max-width: 500px;
    margin: 0 auto;
}

/* Auth Section */
.auth-section {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0 2rem;
}

.login-form .field {
    margin-bottom: 1.2rem;
}

.email-input {
    border-radius: 15px;
    border: 2px solid #e9ecef;
    padding: 1.2rem 1.2rem 1.2rem 4.5rem;
    font-size: 1.1rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(255, 255, 255, 0.9);
}

.email-input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.125rem rgba(102, 126, 234, 0.25);
    transform: translateY(-2px);
}

/* Email input icon alignment */
.control.has-icons-left .icon.is-left {
    top: 50%;
    transform: translateY(-50%);
    left: 0rem;
    color: #667eea;
    z-index: 5;
}

.login-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 15px;
    padding: 1.2rem 2rem;
    font-size: 1.1rem;
    font-weight: 700;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: none;
}

.login-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

.auth-help {
    color: #6c757d;
    font-size: 0.9rem;
    text-align: center;
    margin-top: 1rem;
    line-height: 1.5;
}

.auth-help i {
    margin-right: 0.5rem;
    color: #667eea;
}

/* Verification Section */
.verification-section {
    text-align: center;
}

.verification-title {
    color: #2c3e50;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.verification-title i {
    color: #28a745;
}

.verification-text {
    color: #5a6c7d;
    margin-bottom: 2rem;
    line-height: 1.6;
}

.code-inputs {
    margin-bottom: 2rem;
}

.code-input input {
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
    border-radius: 12px;
    border: 2px solid #e9ecef;
    width: 60px;
    height: 60px;
    transition: all 0.3s ease;
}

.code-input input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
    transform: scale(1.05);
}

.verification-actions .button {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
    border-radius: 15px;
    font-weight: 700;
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.verification-actions .button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(40, 167, 69, 0.4);
}

.invalid-code-message {
    margin-top: 1rem;
}

.resend-link {
    color: #667eea;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
}

.resend-link:hover {
    color: #764ba2;
}

/* Dashboard Link */
.dashboard-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 15px;
    padding: 1.2rem 2rem;
    font-size: 1.1rem;
    font-weight: 700;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: none;
}

.dashboard-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* Carousel Container */
.carousel-container {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    background: white;
    padding: 1rem;
    margin: 0 2rem;
}

/* Mobile Responsiveness for Hero */
@media screen and (min-width: 769px) and (max-width: 1200px) {
    .brand-title {
        font-size: 2.5rem;
        padding: 0 0.5rem;
    }
    
    .brand-text {
        padding: 0 1.5rem;
        font-size: 0.95em;
    }
    
    .brand-section {
        padding: 0 1rem;
    }
}

@media screen and (max-width: 768px) {
    .hero-main-section {
        min-height: auto;
        padding: 1.5rem 0;
        margin-bottom: 2rem;
        border-radius: 15px;
    }
    
    .brand-title {
        font-size: 2rem;
        flex-wrap: wrap;
        gap: 0.5rem;
    }
    
    .brand-text {
        font-size: 0.9em;
        margin: 0 0.5rem;
        padding: 0 0.5rem;
        white-space: normal;
        min-width: auto;
    }
    
    .brand-subtitle {
        font-size: 1rem;
        margin-bottom: 1.5rem;
    }
    
    .auth-section {
        padding: 1.5rem 1rem;
        border-radius: 15px;
        margin: 0 1rem;
    }
    
    .email-input {
        font-size: 1rem;
        padding: 1rem 1rem 1rem 3rem;
    }
    
    .login-button {
        font-size: 1rem;
        padding: 1rem 1.5rem;
    }
    
    .code-input input {
        width: 50px;
        height: 50px;
        font-size: 1.2rem;
    }
    
    .carousel-container {
        border-radius: 15px;
        margin: 0 1rem 2rem 1rem;
    }
}

@media screen and (max-width: 480px) {
    .brand-title {
        font-size: 1.5rem;
    }
    
    .brand-text {
        margin: 0 0.5rem;
        padding: 0 0.25rem;
        font-size: 0.8em;
        min-width: auto;
        white-space: normal;
    }
    
    .auth-section {
        margin: 0 0.5rem;
        padding: 1.2rem 0.8rem;
    }
    
    .code-input input {
        width: 45px;
        height: 45px;
        font-size: 1.1rem;
    }
    
    .carousel-container {
        margin: 0 0.5rem 2rem 0.5rem;
    }
}

/* Feature sections styling */
.feature-section {
    margin-bottom: 5rem;
    padding: 3rem 0;
    border-bottom: 1px solid #f5f5f5;
}

.feature-section:last-child {
    border-bottom: none;
    margin-bottom: 0.5rem;
}

.feature-image {
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    max-width: 100%;
    height: auto;
}

.feature-image:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.18);
}

.clickable-image {
    cursor: pointer;
}

.feature-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
}

.feature-text h3 {
    margin-bottom: 2.5rem;
    color: #2c3e50;
    font-weight: 700;
    font-size: 1.75rem;
    letter-spacing: -0.025em;
    line-height: 1.2;
    position: relative;
    text-align: center;
}

.feature-text h3::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 2px;
}

.feature-text.has-text-right h3::after {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
}

.feature-text p {
    color: #5a6c7d;
    line-height: 1.8;
    font-size: 1.1rem;
    font-weight: 400;
    margin: 0;
    text-align: justify;
}

/* Main functionality title styling */
.title.has-text-centered.is-3 {
    color: #2c3e50;
    font-weight: 800;
    margin-bottom: 4rem !important;
    position: relative;
    font-size: 2.5rem;
    letter-spacing: -0.02em;
}

.title.has-text-centered.is-3::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 2px;
}

/* Mobile responsiveness */
@media screen and (max-width: 768px) {
    .feature-section {
        margin-bottom: 3rem;
        padding: 2rem 0;
    }
    
    .feature-text {
        text-align: center !important;
        padding: 1.5rem 1rem;
    }
    
    .feature-text.has-text-right {
        text-align: center !important;
    }
    
    .feature-text h3 {
        font-size: 1.5rem;
        margin-bottom: 2rem;
    }
    
    .feature-text h3::after {
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%);
    }
    
    .feature-text p {
        font-size: 1rem;
        text-align: center;
    }
    
    .title.has-text-centered.is-3 {
        font-size: 2rem;
        margin-bottom: 3rem !important;
    }
}

/* Image Modal Styling */
.image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
}

.modal-content {
    position: relative;
    z-index: 10000;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-image-container {
    position: relative;
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 100%;
    max-height: 100%;
}

.modal-image {
    max-width: 100%;
    max-height: 80vh;
    width: auto;
    height: auto;
    border-radius: 8px;
    display: block;
}

.modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10001;
}

.modal-close:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: scale(1.1);
}

.modal-close span {
    color: white;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
}

/* Mobile modal adjustments */
@media screen and (max-width: 768px) {
    .modal-content {
        max-width: 95vw;
        max-height: 95vh;
    }
    
    .modal-image-container {
        padding: 15px;
    }
    
    .modal-image {
        max-height: 85vh;
    }
    
    .modal-close {
        width: 35px;
        height: 35px;
        top: 5px;
        right: 5px;
    }
    
    .modal-close span {
        font-size: 20px;
    }
}

/* Call to Action Section */
.cta-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 20px;
    margin: 4rem 0;
    padding: 4rem 2rem;
    position: relative;
    overflow: hidden;
}

.cta-section::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(102, 126, 234, 0.1) 0%, transparent 70%);
    animation: float 6s ease-in-out infinite;
}

@keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
}

.cta-title {
    color: #2c3e50;
    font-weight: 800;
    margin-bottom: 1.5rem;
    position: relative;
    z-index: 2;
}

.cta-subtitle {
    color: #5a6c7d;
    line-height: 1.7;
    margin-bottom: 3rem;
    font-size: 1.2rem;
    position: relative;
    z-index: 2;
}

.cta-benefits {
    margin-bottom: 3rem;
    position: relative;
    z-index: 2;
}

.benefit-item {
    text-align: center;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.benefit-item .icon {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.benefit-item .icon i {
    display: block;
}

.benefit-text {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1rem;
}

.cta-buttons {
    position: relative;
    z-index: 2;
}

.cta-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 50px;
    padding: 1.5rem 3rem;
    font-size: 1.1rem;
    font-weight: 700;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: none;
}

.cta-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

.cta-note {
    margin-top: 1rem;
    color: #6c757d;
    font-size: 0.9rem;
    font-style: italic;
}

/* Mobile CTA adjustments */
@media screen and (max-width: 768px) {
    .cta-section {
        margin: 2rem 0;
        padding: 3rem 1.5rem;
        border-radius: 15px;
    }
    
    .cta-title {
        font-size: 1.8rem;
        margin-bottom: 1rem;
    }
    
    .cta-subtitle {
        font-size: 1.1rem;
        margin-bottom: 2rem;
    }
    
    .cta-benefits {
        margin-bottom: 2rem;
    }
    
    .benefit-item {
        padding: 0.5rem;
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .benefit-item .icon {
        margin-bottom: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .cta-button {
        padding: 1.2rem 2rem;
        font-size: 1rem;
        width: 100%;
    }
}
</style>
